<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="8" style="text-align: start">
                <strong>{{$t('companyChart')}}</strong>
              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="status_form ==0"  class="mr-1 ml-1" @click="insert_data(0)"
                         type="submit" size="sm" color="secondary">
                  {{ $t('buttons.submit') }}
                </CButton>
                <CButton v-if="status_form !=0" @click="insert_data(0)"
                         type="submit" size="sm" color="secondary">
                  {{ $t('buttons.edit') }}
                </CButton>
                <CButton v-if="status_form!=0" @click="emptyList()"
                         class="mr-1"
                         type="reset" size="sm" color="secondary">
                  {{ $t("buttons.cancel") }}
                </CButton>


              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody>
            <CRow>


              <CCol col="6">
                <CCard>
                  <CCardHeader>
                    <strong>{{$t('jobUnitList')}}</strong>
                  </CCardHeader>
                  <CCardBody>
                    <CRow form class="form-group">
                      <CCol tag="label" sm="3" class="col-form-label">
                        {{$t('jobUnits')}}
                      </CCol>
                      <CCol sm="8">
                        <treeselect
                            :appendToBody="true"
                            v-model="selected_chart"
                            :options="data_accounting"
                            :normalizer="normalizer_filter_item"

                        />
                      </CCol>

                    </CRow>

                    <CDataTable
                        :items="items"
                        :fields="fields"

                        :items-per-page="20"
                        hover
                        sorter
                        striped
                        border
                        column-filter
                        pagination
                    >
                      <template #row="{item,index}">

                        <td style="text-align: center">

                        <p >{{ index + 1 }}</p>

                        </td>

                      </template>
                      <template #name="{item}">

                        <td>
                          <p >{{ item.title }}</p>

                        </td>

                      </template>


                      <template #parentId="{item}">

                        <td>
                          <div>
                            {{ get_parent(item) }}
                          </div>
                        </td>

                      </template>


                      <template #operation="{item}">
                        <td>


                          <CIcon @click.native="delete_item_dialog(item)" class="text-danger" name="cilTrash"/>

                        </td>
                      </template>


                    </CDataTable>
                  </CCardBody>
                  <CCardFooter>

                  </CCardFooter>
                </CCard>

              </CCol>
              <CCol md="6">
                <CCard>
                  <CCardHeader>
                    <CRow>
                      <CCol col="8" style="text-align: start">
                        <strong>{{$t('addCompanyChart')}}</strong>
                      </CCol>

                    </CRow>
                  </CCardHeader>

                  <CCardBody>
                    <CRow>


                      <CCol col="6">
                        <CRow form class="form-group">
                          <CCol tag="label" sm="3" class="col-form-label">
                            {{$t('position')}}
                          </CCol>
                          <CCol sm="9">
                            <treeselect
                                :appendToBody="true"
                                v-model="selected_chart_add"

                                :options="data_accounting"
                                :normalizer="normalizer_filter_item"

                            />
                          </CCol>

                        </CRow>
                      </CCol>
                      <CCol col="6">
                        <CRow form class="form-group">
                          <CCol tag="label" sm="3" class="col-form-label">
                            {{$t('jobTitle')}}
                          </CCol>
                          <CCol sm="9">
                            <treeselect
                                v-model="selected_job"
                                :multiple="true"
                                :options="jobs"
                                :normalizer="normalizer_filter_job"
                                :limit="0"
                            />
                          </CCol>

                        </CRow>

                        <!--                        <CSelect-->
                        <!--                            label="شغل"-->
                        <!--                            horizontal-->
                        <!--                            :options="jobs"-->
                        <!--                            :value.sync="selected_job"-->
                        <!--                        />-->
                      </CCol>
                    </CRow>

                  </CCardBody>
                </CCard>

              </CCol>
            </CRow>

          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="6">
      </CCol>


    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'


var items = [];


export default {
  name: 'Login',
  components: {
    Treeselect,

  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,

      name: '',
      file: '',
      color: '#ffffff',
      previewImage: '/img/placeholder.png',
      description: '',
      data_accounting: [],
      selected_chart: null,
      data_with_children: [],
      items: [],
      jobs: [],
      selected_job: [],
      selected_chart_add: null,
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:3%'},
        // {key: 'title', label: this.$t('tables.name'), _style: 'width:20%'},
        {key: 'jobTitle', label: this.$t('jobTitle'), _style: 'width:20%'},
        {key: 'operation', label: "", filter: false, _style: 'width:5%;'},
      ],
      collapseDuration: 0,
      status_form: 0,
      normalizer_filter_item(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,

        }
      },
      normalizer_filter_job(node) {
        return {
          id: node.value,
          label: node.label,
        }
      },
    }
  }, mounted() {
    this.$root.root_validate_errors = [];
    this.get_departments();
    this.get_lists();
    this.get_jobs();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'selected_chart': function () {
      this.get_lists();
    }
  },
  methods: {
    get_parent(item) {
      return this.data_with_children.filter(item2 => item2.id == item.mainDepartemanId)[0].title
    },
    open_file_selector() {
      this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' && this.file != '' && this.description != '' && this.color != '') {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }
      if (this.file == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertImage'));
      }
      if (this.color == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertColor'));
      }
      if (this.description == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertSummary'));
      }
      return false;
      // e.preventDefault();
    },
    get_style(color) {
      return {
        backgroundColor: color

      }
    },
    edit_item(item) {
      this.name = item.title;
      this.selected_chart = item.mainDepartemanId;
      this.status_form = item.id;

    },
    emptyList() {
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

    },
    get_jobs() {
      var self = this;

      const formData = new FormData();


      formData.append('RecType', 1);


      axios.post('MainDeparteman/GetData', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.jobs = [];
          var filtered = content_data.data.filter(item => item.recType == 1);
          self.jobs = self.sort_array(
              self.jobs, filtered,
              'id', 'title');
          if (self.jobs.length) {
            self.selected_job = self.jobs[0].value;
          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_departments() {
      var self = this;

      const formData = new FormData();

      formData.append('Id', 0);


      axios.post('MainDeparteman/GetData', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {

          self.data_accounting = []


          self.data_with_children = response.data.data;
          self.data_with_children = self.data_with_children.filter(item2 => item2.recType == 0);

          self.data_with_children.forEach((val) => {
            if (val.parentId == 0) {

              var obj = {
                "name": val.title,

                parentId: val.parentId,
                id: val.id,
                recType: val.recType,

                // "selected":true,
                // mate: self.get_mates(val.id, response.data.data)
              };
              if (self.get_childrens(val.id, self.data_with_children)) {
                obj.children = self.get_childrens(val.id, self.data_with_children)
              }

              self.data_accounting.push(obj);
            }

          });
          if (self.selected_node == 0) {
            self.selected_node = self.data_accounting.children[0];
            // this.selected_node = node
          }
          // self.get_mate_accounts()

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_childrens(parent_id, list) {
      var array = [];
      list.forEach((val2) => {

        if (parent_id == val2.parentId && val2.recType == 0) {
          var obj = {
            name: val2.title,
            id: val2.id,
            // mate: this.get_mates(val2.id, list),
            recType: val2.recType,

            parentId: val2.parentId,
            image_url: '/img/avatars/custom.png',

          };
          if (this.get_childrens(val2.id, list)) {
            obj.children = this.get_childrens(val2.id, list)
          }
          array.push(obj);

          // val2.inserted = true;

        }
        // if (parent_id == val2.parentId &&val2.recType == 1) {
        //   var obj2 = {
        //     name: val2.title,
        //     id: val2.id,
        //     children: this.get_childrens(val2.id, list),
        //     // mate: this.get_mates(val2.id, list),
        //     recType: val2.recType,
        //
        //     class:["my_mate"],
        //     parentId: val2.parentId,
        //     image_url: '/img/avatars/custom2.png',
        //
        //   }
        //   array.push(obj2);

        // val2.inserted = true;

        // }
      });
      if (array.length > 0) {

        return array;

      } else {
        return null;

      }

    },

    get_lists() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);

      const formData = new FormData();


      // formData.append('RecType', 1);

      formData.append('ParentId', this.selected_chart);

      axios.post('Departeman/Getdata', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.items = self.items.filter(item => item.parentId == self.selected_chart);

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goSubCategories(item) {

      this.$router.push({path: "/dashboard/products/list-brand/" + item.id})
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    handleFileUpload(files, e) {
      this.file = e.target.files[0];
      this.previewImage = URL.createObjectURL(this.file);
    },
    insert_data(index) {
console.log("index insert is",index,"in",this.selected_job.length);
      if (this.selected_chart_add == null || this.selected_job.length == 0 || this.selected_job.length == null) {
        this.$root.modal_component.show_validate_errors([this.$t('fillAllFields')])

        return false;
      }
      // this.addGroupModal = false;


      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "Departeman/Add";

      } else {
        url = "Departeman/Update";
        formData.append('id', this.status_form)

      }
      // Departeman/Getdata
      //
      //
      // Departeman/Delete
      //
      // Id
      //
      //
      formData.append('ParentId', this.selected_chart_add);
      formData.append('JobId', this.selected_job[index]);


      // formData.append('title', this.name);
      // formData.append('branchId', this.selected_branch);

      axios.post(url, formData, {}).then((res) => {



        if (index < self.selected_job.length   - 1) {
          self.insert_data(index + 1)
        } else {
          self.get_lists();
          self.$root.modal_component.show_api_response_modals(res);
          self.selected_job= []
        }


      })

          .catch(function (error) {
            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "Departeman/Delete";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
